module.exports = __webpack_public_path__ + "img/app4.b830ee95.png";